import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { isStaticRender } from 'helpers/ContentHelper';
import { setHelmetTags } from 'helpers/HelmetHelper';
import Loader from 'components/Loader';
import { fetchGallery } from './PhotoGalleryActions';
import { showLoader } from './PhotoGalleryHelper';
import PhotoGalleryImages from './Components/PhotoGalleryImages';
import Style from './PhotoGallery.module.scss';

class PhotoGallery extends Component {
  componentDidMount() {
    const { url, accessToken, deviceId, fetchGallery } = this.props;
    if (url && fetchGallery && !isStaticRender()) {
      fetchGallery(url, accessToken, deviceId);
    }
  }

  render() {
    const { panel, seo } = this.props;

    if (showLoader(panel)) return <Loader data-test="web-photo-gallery-loader" />;

    const headline = _.get(panel, 'headline', null);
    const images = _.get(panel, 'items.member', null);
    const description = _.get(panel, 'description', null);

    return (
      <div className={Style.container}>
        {setHelmetTags(seo)}
        <div className={Style.title} data-test="web-photo-gallery-title">
          {headline}
        </div>
        {description && (
          <div className={Style.description} data-test="web-photo-gallery-description">
            {description}
          </div>
        )}
        <PhotoGalleryImages images={images} theme={Style} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    panel: state.photoGallery.panel,
    seo: state.photoGallery.seo,
  };
}

PhotoGallery.defaultProps = {
  accessToken: null,
  deviceId: null,
  panel: null,
  seo: null,
  url: null,
};

PhotoGallery.propTypes = {
  accessToken: PropTypes.string,
  deviceId: PropTypes.string,
  fetchGallery: PropTypes.func.isRequired,
  panel: PropTypes.shape({}),
  seo: PropTypes.shape({}),
  url: PropTypes.string,
};

export default connect(
  mapStateToProps,
  { fetchGallery },
)(PhotoGallery);
